import { montserratBold, montserratNormal } from '@/assets/fonts/montserrat'
import { t } from 'i18next'
import React from 'react'

export default function FeatureReconciliation({videoRef}) {
  return (
    <div className='flex relative w-full h-full p-8 bg-gray-cool-50 rounded-lg overflow-hidden'>
      <div className='border h-fit w-auto lg:w-[380px] overflow-hidden flex border-gray-cool-200 rounded-lg relative'>
        <video id="videoRecon" ref={videoRef} src={"/features/freya-recon.mp4"} autoPlay loop></video>
      </div>
      <div className='pl-8 block w-auto lg:w-[450px]'>
        <h3 className={`${montserratBold.className} text-gray-cool-700 text-[20px] lg:text-[24px]`}>{t('recon_feature_list_detail_title_1')}</h3>
        <p className={`${montserratNormal.className} text-gray-cool-500 lg:text-[20px] text-wrap py-6`}>{t('recon_feature_list_detail_description_1_part_1')}</p>
        <p className={`${montserratNormal.className} text-gray-cool-500 lg:text-[20px] text-wrap`}>{t('recon_feature_list_detail_description_1_part_2')}</p>
      </div>
    </div>
  )
}
